export default "__VITE_ASSET__yZFRtROG__"